import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueI18n from 'vue-i18n'

import Router from "./router";

Vue.use(VueI18n);

Vue.config.productionTip = false


//Localization
import de from "./assets/i18n/de";
import en from "./assets/i18n/en";

const i18n = new VueI18n({
  locale: getLanguage(), // set locale
  messages: {
    de: de,
    en: en
  } // set locale messages
});

export function getLanguage(){
  return (window.localStorage.getItem("lang") || navigator.language || navigator.userLanguage).split("-")[0];
}

new Vue({
  i18n,
  vuetify,
  router: Router,
  render: h => h(App)
}).$mount('#app')
